import auth from "../firebase/auth";
import { signOut } from "firebase/auth";
import { useEffect, useState } from "react";
import axiosJwt from "../utils/axiosJwt";
import { useNavigate } from "react-router-dom";

export default function useAxiosJwtQuery(url) {
  const navigate = useNavigate();
  const [data, setData] = useState();

  const fetch = () => {
    axiosJwt(process.env.REACT_APP_SERVER_ENDPOINT + url)
      .then(({ data }) => {
        setData(data);
      })
      .catch((error) => {
        if ([401, 403].includes(error?.response?.status)) {
          signOut(auth);

          localStorage.removeItem("token");

          navigate("/login");
        }
      });
  };

  useEffect(() => {
    fetch();
  }, []);

  return [data, fetch];
}
